import { ConfigService } from 'src/config/config.service';
import { Router } from '@angular/router';
import { Actions, Effect,ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import * as AdmPerfilActions from '../../../actions/';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { AppState } from 'src/app/store/app.reducer';
import { Store } from '@ngrx/store';
import { perfilesService } from 'src/app/services/SiicartAdm/perfilesAdm.service';

@Injectable()
export class admPerfilEffects {

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private PerfilService: perfilesService,
    private config: ConfigService,
    private router: Router
  ) {}

  // effects go here
    @Effect()
    AdmGetPerfil$: Observable<any> = this.actions$.pipe(
        ofType(AdmPerfilActions.AdmPerfilActionTypes.GET_ADM_PERFIL),
        switchMap((action: AdmPerfilActions.AdmGetPerfil) => {
            return this.PerfilService.ObtenerPerfiles()
                .pipe(
                    map((resultado: any) => {
                        return new AdmPerfilActions.AdmSuscessPerfil(resultado, 'ListPerfiles');
                    }),
                    catchError(error => of (new AdmPerfilActions.AdmFailPerfil({ error })))
                );
            }
        )
    );

    @Effect()
    AdmSetPerfil$: Observable<any> = this.actions$.pipe(
        ofType(AdmPerfilActions.AdmPerfilActionTypes.SET_ADM_PERFIL),
        switchMap((action: AdmPerfilActions.AdmSetPerfil) => {
            return this.PerfilService.AgrModfPerfil(action.DatosPerfil)
                .pipe(
                    map((resultado: any) => {
                        return new AdmPerfilActions.AdmSuscessPerfil(resultado, 'SetPerfil');
                    }),
                    catchError(error => of (new AdmPerfilActions.AdmFailPerfil({ error })))
                );
            }
        )
    );

    
    @Effect()
    AdmDeletePerfil$: Observable<any> = this.actions$.pipe(
        ofType(AdmPerfilActions.AdmPerfilActionTypes.DELETE_ADM_PERFIL),
        switchMap((action: AdmPerfilActions.AdmDeletePerfil) => {
            return this.PerfilService.EliminarPerfil(action.ObjDel)
                .pipe(
                    map((resultado: any) => {
                        return new AdmPerfilActions.AdmSuscessPerfil(resultado, 'DeletePerfiles');
                    }),
                    catchError(error => of (new AdmPerfilActions.AdmFailPerfil({ error })))
                );
            }
        )
    );
}
